<template>
  <v-img
    height="500"
    :src="imageUrl"
    v-if="imageUrl"
    :alt="data"
  ></v-img>
</template>

<script>
import { defineComponent } from 'vue'
import { getImage } from '../../services/formServices';

export default defineComponent({
  name: 'ImageComponent',
  props: {
    data: String, // Filename of the image
  },
  data() {
    return {
      imageUrl: null, // Holds the URL for the image after it's fetched
    }
  },
  watch: {
    data(newVal) {
      // Whenever the `data` prop changes (filename), fetch the new image
      this.fetchImage(newVal);
    }
  },
  mounted() {
    // Fetch the image when the component mounts
    this.fetchImage(this.data);
  },
  methods: {
    async fetchImage(filename) {
      try {
        const [ file, ext ] = filename.split('.')
        const response = await getImage({file, ext})
        if (response) {
          this.imageUrl = URL.createObjectURL(response.data);
        } else {
          console.error('Failed to load image');
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    }
  }
})
</script>


